module.exports = __webpack_public_path__ + "images/tencent_docs/sheet-e694f06c8ce95454dd64d4739a466fd5.svg";